


























































































import Vue from 'vue'
import { Component, Prop, Emit, Watch } from 'vue-property-decorator'

@Component
export default class AppDialog extends Vue {
  @Prop(Boolean) value!: boolean
  @Prop({ type: [Number, String], default: 430 }) readonly width!: number | string
  @Prop({ type: [Number], default: 238 }) readonly height!: number
  @Prop({ type: String, default: 'Confirm' }) readonly title!: string
  @Prop({ type: String, default: '' }) readonly text!: string
  @Prop({ type: Boolean, default: false }) readonly disableConfirm!: boolean
  @Prop({ type: String, default: 'OK' }) readonly confirmText!: string
  @Prop({ type: String, default: '' }) readonly highlightTitle!: string
  @Prop({ type: Boolean, default: false }) readonly showBackBtn!: boolean
  @Prop({ type: Boolean, default: false }) readonly confirmBtnDisable!: boolean
  @Prop({ type: Boolean, default: false }) readonly isLoading!: boolean
  @Prop({ type: Boolean, default: false }) readonly showWarning!: boolean
  @Prop({ type: Boolean, default: false }) readonly noAction!: boolean

  model = false

  newCaseInput = {
    name: '',
    gender: '',
    birthday: '',
    phone: '',
    memo: ''
  }

  windowSize = {
    w: 0,
    h: 0
  }

  get dialogHeight () {
    const { height, windowSize: { h } } = this

    return height > h - 50 ? h - 50 : height
  }

  mounted () {
    this.model = this.value
  }

  @Emit('input')
  closeDialog () {
    return false
  }

  @Emit('confirm')
  confirmDialog () {}

  @Emit('cancel')
  cancelDialog () {
    this.closeDialog()
  }

  @Emit('back')
  backDialog () {
    // do nothing
  }

  @Watch('value')
  valueChanged (val: boolean) {
    this.model = val
  }

  keyDownHandler (e: KeyboardEvent) {
    if (e.key === 'Enter' && e.ctrlKey) {
      this.confirmDialog()
    }
  }

  onResize () {
    this.windowSize = { w: window.innerWidth, h: window.innerHeight }
  }
}
